import React from 'react';
import classnames from 'classnames';

import getImagePath from 'utils/getImagePath';

interface Props {
  image: string,
  nature?: string,
}

export default function TooltipImage({ image, nature }: Props) {
  return (
    <div
      className={classnames(
        image === 'actions' && 'icon--currency',
        nature === 'Status' && 'icon--circular',
        'icon tooltip__icon',
      )}
    >
      <img src={getImagePath({ icon: image, type: 'small-icon'})} alt={image} />
    </div>
  );
}
